<template>
  <div class="g-page__row">
    <ul class="list-none list-margin-start mb-none">
      <li class="p-base border-1 border-solid border-border shadow-card hover:shadow-cardHover mb-sm last:mb-none rounded-lg transition transform ease-in-out duration-150" v-bind:key="index" v-for="(email, index) in emails">
          <RouterLink class="no-underline text-darkFont block" :to="{ name: 'EmailTemplateEdit', params: { emailId: email.id }}">
            <b>{{ $t(`branding.templateNames.${email.identifier}`) }}</b>
            <span class="block text-14">
              <b>{{ $t('branding.subject') }}</b>
              {{ email.subject }}
            </span>
          </RouterLink>
      </li>
    </ul>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  name: 'EmailsView',
  mounted() {
    if (this.hasFeature) this.$store.dispatch('emails/PAGINATE', { page: 1 });
  },
  computed: {
    ...mapGetters({
      emails: 'emails/pagedResults',
      userHasRole: 'roles/userHasRole',
    }),
    permissionBranding() {
      return this.userHasRole('super-admin');
    },
    hasFeature() {
      return this.$store.getters['plan/permissions'].branding;
    },
  },
};
</script>
